import { configField, makeConfig } from "@megaron/config-manager";
import { Serializers } from "@megaron/serializers";

export const ShopifyAdminConfig = makeConfig(() => ({
  shopifyAdminApiToken: configField({ nonProd: "" }),
  shopifyStoreDomain: configField({
    nonProd: "https://megaron-sandbox.myshopify.com/",
    prod: "https://megaron-eu.myshopify.com/",
    test: "",
  }),
  useShopifyMockClient: configField({ default: false, test: true }, Serializers.boolean),
}));
